export enum PRODUCT_COLLECTIONS_VARIATIONS {
  Control = 'ProductCollectionsControl',
  Enabled1 = 'ProductCollectionsEnabled1',
  Enabled2 = 'ProductCollectionsEnabled2',
}

export const PRODUCT_COLLECTIONS_EXPERIMENT_NAME = 'fy26_q1_collectionsinquickview'
export const PRODUCT_COLLECTIONS_FAVORITES_QUERY_KEY = 'favoritesByProductKey/collections'
